import { useState, useEffect} from 'react'
import { FilterIcon, max_price, min_price, shopOption, slugify } from '../../base'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

function AllProductFilter({ pshop, pcategory, pavailability, pprice__gte, pprice__lte, psort_by }) {
  const [filterName, setFilterName] = useState('shop')
  const [shop, setShop] = useState('all')
  const [category, setCategory] = useState('all')
  const [availability, setAvailability] = useState('all')
  const [priceGte, setPriceGte] = useState(0)
  const [priceLte, setPriceLte] = useState(max_price)
  const [sortBy, setSortBy] = useState('d-no')

  const category_options = useSelector((state)=>state.appSlice.category_options)

  const navigate = useNavigate()

  function applyFilter() {
    navigate(`/p/shop/${slugify(shop)}/category/${slugify(category)}/products/?avl=${availability}&p_ge=${priceGte}&p_le=${priceLte}&s_b=${sortBy}`)
  }

  function resetFilter() {
    setShop(pshop ? pshop.replace(/\-+/g, ' ') : 'all')
    setCategory(pcategory ? pcategory.replace(/\-+/g, ' ') : 'all')
    setAvailability(pavailability ? pavailability : 'all')
    setPriceGte(pprice__gte ? pprice__gte : min_price)
    setPriceLte(pprice__lte ? pprice__lte : max_price)
    setSortBy(psort_by ? psort_by : 'd-no')
  }

  function priceChange(e) {
    const { name, value } = e.target
    if (name === 'priceGte' && value < priceLte) {
      setPriceGte(Number(value))
    }
    if (name === 'priceLte' && value > priceGte) {
      setPriceLte(Number(value))
    }

  }

  useEffect(() => {
    resetFilter()
  }, [pshop, pcategory, pavailability, pprice__gte, pprice__lte, psort_by])

  return (
    <div className='productFilter'>
      <div className='d-flex refine' data-bs-toggle="offcanvas" data-bs-target="#offcanvasTop" aria-controls="offcanvasTop"><span><FilterIcon /></span>Filter</div>


      <div className="offcanvas offcanvas-top" tabIndex="-1" id="offcanvasTop" aria-labelledby="offcanvasTopLabel">
        <div className="offcanvas-header">
          <h5 className="offcanvas-title h5 heading" id="offcanvasTopLabel">Apply Filters and Sort result </h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body ps-1 pe-1 pt-0 ps-sm-4 pe-sm-4" style={{overflowX : 'hidden'}}>
          <div className='row' style={{justifyContent : 'center'}}>
            <div className='col-md-3 col-lg-2'>
              <div className='filterTab flex-md-column flex-row mb-3'>
                <div className={`h6 ${filterName === 'shop' ? 'active' : ''}`} onClick={() => setFilterName('shop')}>Shop</div>
                <div className={`h6 ${filterName === 'category' ? 'active' : ''}`} onClick={() => setFilterName('category')}>Category</div>
                <div className={`h6 ${filterName === 'availability' ? 'active' : ''}`} onClick={() => setFilterName('availability')}>Availability</div>
                <div className={`h6 ${filterName === 'price' ? 'active' : ''}`} onClick={() => setFilterName('price')}>Price</div>
              </div>
            </div>
            <div className='col-md-9 col-lg-7 mb-3'>
              <div className={`filterOption  ${filterName === 'shop' ? 'd-flex row' : 'd-none'}`}>
                {
                  shopOption.map((item, index) => {
                    return (
                      <div className='col-12 col-sm-6' key={index}>
                        <label style={{ fontSize: '15px' }}><input type='radio' name='shop' value={item} checked={item === shop} onChange={(e) => setShop(item)} />{item === 'all' ? 'All Shops' : item}</label>
                      </div>
                    )
                  })
                }
              </div>
              <div className={`filterOption ${filterName === 'category' ? 'd-flex row' : 'd-none'}`}>
                {
                  category_options && category_options.map((item, index) => {
                    return (
                      <div className='col-6' key={index}>
                        <label style={{ fontSize: '15px' }}><input type='radio' name='category' value={item} checked={item === category} onChange={(e) => setCategory(item)} />{item === 'all' ? 'All Category' : item}</label>
                      </div>
                    )
                  })
                }
              </div>
              <div className={`filterOption flex-column ${filterName === 'availability' ? 'd-flex' : 'd-none'}`} style={{ maxWidth: '300px', margin: 'auto' }}>
                <label><input type='radio' name='availability' value={'all'} checked={availability === 'all'} onChange={(e) => setAvailability(e.target.value)}></input>All</label>
                <label><input type='radio' name='availability' value={'in-stock'} checked={availability === 'in-stock'} onChange={(e) => setAvailability(e.target.value)}></input>In Stock</label>
                <label><input type='radio' name='availability' value={'out-of-stock'} checked={availability === 'out-of-stock'} onChange={(e) => setAvailability(e.target.value)}></input>Out Of Stock</label>
              </div>
              <div className={`filterOption flex-column w-75 ${filterName === 'price' ? 'd-flex' : 'd-none'}`} style={{ maxWidth: '400px', margin: 'auto' }}>
                <label>Lower Price : {priceGte}</label>
                <input type='range' name='priceGte' step={500} onChange={(e) => priceChange(e)} min={min_price} max={max_price} value={priceGte} />
                <label>Higher Price : {priceLte}</label>
                <input type='range' name='priceLte' step={500} onChange={(e) => priceChange(e)} min={min_price} max={max_price} value={priceLte} />
              </div>
            </div>
            <div className='col-11 col-md-6 col-lg-3 text-center'>
              <label>Sort / Order By</label>
              <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                <option value={'d-no'}>Date, New to Old</option>
                <option value={'d-on'}>Date, Old to New</option>
                <option value={'p-hl'}>Price, High to Low</option>
                <option value={'p-lh'}>Price, Low to High</option>
                <option value={'ds-hl'}>Discount, High to Low</option>
                <option value={'ds-lh'}>Discount, Low to High</option>
                <option value={'u-s'}>Top Selling</option>
              </select>
              <div className='d-flex mt-4 justify-content-between flex-row flex-lg-column'>
                <button className='secondryButton ms-1 me-1' onClick={() => resetFilter()}>Reset All</button>
                <button className='secondryButton ms-1 me-1 mb-lg-3' onClick={() => applyFilter()} data-bs-dismiss="offcanvas" aria-label="Close">Get Products</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AllProductFilter